
export const data = {

    "mac":[

        {"name": "MacBook Air", "url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/macbookair__ej39du0gz4uq_large.svg"},

        {"name":"MacBook Pro","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/macbookpro__enfip2k1cxkm_large.svg" },

        {"name":"iMac","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/imac__dkswmjfqeziq_large.svg" },

        {"name":"iMac Pro","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/imac_pro__eer4bfwlutme_large.svg" },

        {"name":"Mac Pro","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/mac_pro__bn92faz71k6a_large.svg"}, 

        {"name":"Mac mini","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/macmini__c6u0it831y0y_large.svg"}, 

        {"name":"Compare","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/mac_comp__ee2pokmcxh26_large.svg" },

        {"name":"Pro Display","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/pro_display_xdr__do0vjpny1kqe_large.svg"}, 

        {"name":"Accessories","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/mac_acc__fy6vtx5eqoyi_large.svg"}, 

        {"name":"Mac Osx","url":"https://www.apple.com/v/mac/home/ai/images/familybrowser/mac_osx__dntc9ef2limq_large.svg"}

    ],

    "ipad":[

        {"name":"iPad Pro", "url": "https://www.apple.com/v/ipad/home/au/images/chapternav/ipadpro_light__dxq7nxjgsd2e_large.svg"},

        {"name":"iPad Air", "url": "https://www.apple.com/v/ipad/home/au/images/chapternav/ipadair_light__gan6yfrffc66_large.svg"},

        {"name":"iPad", "url":"https://www.apple.com/v/ipad/home/au/images/chapternav/ipad_light__expohijp19si_large.svg"},

        {"name":"iPad Mini", "url": "https://www.apple.com/v/ipad/home/au/images/chapternav/ipadmini_light__bxpulkud30s2_large.svg"},

        {"name":"Compare", "url":"https://www.apple.com/v/ipad/home/au/images/chapternav/ipad_comp_light__f80dzq6i8sq6_large.svg"},

        {"name":"Apple Pencil","url":"https://www.apple.com/v/ipad/home/au/images/chapternav/apple_pencil_light__e9zorbynwqie_large.svg"},

        {"name":"Smart Keyboard","url":"https://www.apple.com/v/ipad/home/au/images/chapternav/keyboard_light__cjbr6d6i2vbm_large.svg"},

        {"name":"Accessories","url":"https://www.apple.com/v/ipad/home/au/images/chapternav/ipad_acc_light__ebtftz3r2rwy_large.svg"},

        {"name":"iPadOS","url":"https://www.apple.com/v/ipad/home/au/images/chapternav/ipados_light__f5xv7yr98tm6_large.svg"}

    ],

    "iphone":[

        {"name":"iPhone 11 Pro","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_11_pro_dark__cchxb3bv66vm_large.svg"},

        {"name":"iPhone 11","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_11_dark__exagpxb8zh4y_large.svg"},

        {"name":"iPhone Xr","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_xr_dark__gmkx1gdvqqum_large.svg"},

        {"name":"iPhone 8","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_8_dark__d4f1b8j5cwia_large.svg"},

        {"name":"Compare","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_comp_dark__ganfgd3pa9m6_large.svg"},

        {"name":"Apple Card","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_apple_card_dark__fsk0oaya7eqi_large.svg"},

        {"name":"AirPods","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_airpods_dark__b5yw8pv4m4z6_large.svg"},

        {"name":"Accessories","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_acc_dark__b5fvf10sbhci_large.svg"},

        {"name":"iOS 13","url":"https://www.apple.com/v/iphone/home/ab/images/chapternav/iphone_ios_dark__bb9g9sts3q76_large.svg"}

    ],

    "watch":[

        {"name":"Apple Watch Series 5","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_series_2__bk595ih4bliu_large.svg"},

        {"name":"Apple Watch Nike","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_nike__mkjgkrrlq2ye_large.svg"},

        {"name":"Apple Watch Hermes","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_hermes__b1zeoxbn0df6_large.svg"},

        {"name":"Apple Watch Edition","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_series_2__bk595ih4bliu_large.svg"},

        {"name":"Apple Watch Series 3", "url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_edition__botzv6l1ftua_large.svg"},

        {"name":"Compare","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_compare__bjddtmfseahe_large.svg"},

        {"name":"Bands","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_bands__f5qi8icu6suq_large.svg"},

        {"name":"AirPods","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_airpods__gdoguo6cstua_large.svg"},

        {"name":"Accessories","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_accessories__fix8lwwxvtu2_large.svg"},

        {"name":"watchOS","url":"https://www.apple.com/v/watch/home/t/images/overview/watch_nav_watch_os__fctkp231ik6e_large.svg"}

    ],

    "tv":[

        {"name":"Apple TV app","url":"https://www.apple.com/v/tv/home/h/images/home/apple_tv_app_dark__blle10nnpq3m_large.svg"},

        {"name":"Apple TV+","url":"https://www.apple.com/v/tv/home/h/images/home/apple_tv_plus_dark__fntbqaxjuouy_large.svg"},

        {"name":"Apple TV 4K","url":"https://www.apple.com/v/tv/home/h/images/home/apple_tv_dark__ern1bz8tkwqe_large.svg"},

        {"name":"Apple TV HD","url":"https://www.apple.com/v/tv/home/h/images/home/apple_tv_dark__ern1bz8tkwqe_large.svg"},

        {"name":"AirPlay","url":"https://www.apple.com/v/tv/home/h/images/home/airplay_dark__dqiw3rzeujma_large.svg"},

        {"name":"Accessories","url":"https://www.apple.com/v/tv/home/h/images/home/accessories_dark__dybfk40y28om_large.svg"}

    ],

    "music":[

        {"name":"Apple Music","url":"https://www.apple.com/v/music/i/images/overview/icons/apple_music_large.svg"},

        {"name":"HomePod","url":"https://www.apple.com/v/music/i/images/overview/icons/homepod_icon_large.svg"},

        {"name":"AirPods","url":"https://www.apple.com/v/music/i/images/overview/icons/airpods_icon_large.svg"},

        {"name":"iPod touch","url":"https://www.apple.com/v/music/i/images/overview/icons/ipod_touch_light_large.svg"},

        {"name":"Music Accessories","url":"https://www.apple.com/v/music/i/images/overview/icons/accessories_large.svg"},

        {"name":"Gift Cards","url":"https://www.apple.com/v/music/i/images/overview/icons/gift_cards_large.svg"}

    ],

    "apple":{"name":"logo","url":"https://www.apple.com/ac/globalnav/4/en_US/images/globalnav/apple/image_large.svg"}

}